export default "__VITE_ASSET__DoDnFRj1__"